import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-mail-send-line"></i>
            投稿爆料
          </span>
          <h2 className="text-2xl md:text-3xl font-display text-foreground-950">{contactInfo.title}</h2>
          <p className="mt-2 text-lg text-primary-500 font-semibold">{contactInfo.subtitle}</p>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{contactInfo.desc}</p>

          <div className="mt-8 bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
            <div className="flex items-center justify-center gap-3 text-lg font-semibold text-primary-600">
              <i className="ri-mail-line text-xl"></i>
              <span>{contactInfo.email}</span>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
              {contactInfo.tips.map((tip, i) => (
                <div key={i} className="flex items-center gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                  {tip}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}